import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { RowDef } from '../../shared/components/table/table.component';
import { BatchTasks } from '../../shared/services/batch-tasks';
import { ModalService } from '../../shared/services/modal.service';
import { NetInfoService } from '../../shared/services/net-info.service';
import { NotificationService } from '../../shared/services/notification.service';
import { CountryTableComponent } from '../country-table/country-table.component';

@Component({
  standalone: false,
  selector: 'app-country-index',
  templateUrl: './country-index.component.html',
  styleUrls: [],
})
export class CountryIndexComponent implements OnInit, OnDestroy {
  selectedRows: RowDef[] = [];
  batchCompleted = 0;
  progressShow = false;
  searchControl = new FormControl();
  private searchSubscription: Subscription;

  @ViewChild(CountryTableComponent, { static: false }) table: CountryTableComponent;

  constructor(
    public netInfoService: NetInfoService,
    public router: Router,
    public notificationService: NotificationService,
    titleService: Title,
    public modal: ModalService
  ) {
    titleService.setTitle('Countries');
  }

  ngOnInit() {
    this.searchSubscription = this.searchControl.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(searchValue => {
      this.onChangeInputSearch(searchValue);
    });
  }

  onCreate() {
    this.table.onCreate();
  }

  onBatchDelete() {
    this.modal
      .confirm()
      .open()
      .result.then(res => {
        if (!res) {
          return;
        }
        this.batchDelete();
      });
  }

  private batchDelete() {
    const tasks = this.selectedRows.map(row => {
      return this.netInfoService.deleteCountry(row.data.id).pipe(
        map(() => {
          this.notificationService.success('Countries deleted', 'Countries');
          row.batch = false;
          this.completeTask();
        }),
        catchError((err, caught) => {
          this.notificationService.error('Country delete an error', 'Countries');
          this.completeTask();
          return caught;
        })
      );
    });
    this.startTasks(tasks);
  }

  onChangeInputSearch(phrase) {
    if (phrase instanceof Event) {
      return;
    }
    this.table.requestParams.search = phrase.trim();
    this.table.update();
  }

  startTasks(tasks: Observable<any>[]) {
    this.progressShow = true;
    this.batchCompleted = 0;
    this.table.loading = true;
    new BatchTasks(tasks).run(4);
  }

  completeTask() {
    this.batchCompleted++;
    if (this.selectedRows.length === this.batchCompleted) {
      this.table.loading = false;
      this.progressShow = false;
      this.selectedRows = [];
      this.table.load();
    }
  }

  batchClear(): void {
    this.progressShow = false;
    this.selectedRows = [];
    this.table.resetBatch();
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
  }
}
